"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./components/OOIComponent/types");
exports.getEnvironment = function (wixCodeApi) { return ({
    isEditor: wixCodeApi.window.viewMode === types_1.ViewMode.EDITOR,
    isPreview: wixCodeApi.window.viewMode === types_1.ViewMode.PREVIEW,
    isSSR: wixCodeApi.window.rendering.env === 'backend',
    isDebug: wixCodeApi.location.query.debug || wixCodeApi.location.query.ssrDebug,
}); };
function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
exports.isValidEmail = isValidEmail;
var COMPONENT_ID;
(function (COMPONENT_ID) {
    COMPONENT_ID["GROUP_LIST"] = "groups";
    COMPONENT_ID["GROUP_PAGE"] = "group";
    COMPONENT_ID["GROUPS_AREA"] = "groups_area";
})(COMPONENT_ID = exports.COMPONENT_ID || (exports.COMPONENT_ID = {}));
function getGroupUrl(baseUrl, groupId) {
    // if baseUrl has an end slash (like: www.example.com/),
    // then remove it and return the site without the end slash
    var base = baseUrl.replace(/\/$/, '');
    return base + "/group/" + groupId + "/discussion";
}
exports.getGroupUrl = getGroupUrl;
// EditorX returns 'False' if formFactor is not 'Desktop'
// Editor returns 'Mobile' if formFactor is not 'Desktop'
function isMobileByFormFactor(formFactor) {
    return formFactor !== 'Desktop';
}
exports.isMobileByFormFactor = isMobileByFormFactor;
//# sourceMappingURL=utils.js.map